import { getErrorMessage } from "@helper/getErrorMessage";
import { isArrayWithElements } from "@helper/utils";
import { increasePagination } from "@hooks/useLoadMore/IncreasePagination";
import {
  FetchMoreJobsFunction,
  MoreJobsRequestData,
} from "@typings/MoreJobsApi";
import { JobsDetailsItem } from "@typings/Storage.d";
import React from "react";

interface LoadMoreJobsHandlerParams {
  lastLoadedJob: JobsDetailsItem | undefined;
  loadMoreData: JobsDetailsItem[];
  renderedJobIds: Set<number>;
  pageSize: number;
  pageNumber: number;
}

export type CreateLoadMoreJobsHandlerProps = {
  requestData: MoreJobsRequestData;
  fetchFunction: FetchMoreJobsFunction;
  setHasMoreJobs: React.Dispatch<React.SetStateAction<boolean>>;
  setRenderedJobIds: React.Dispatch<React.SetStateAction<Set<number>>>;
  setLoadMoreData: React.Dispatch<React.SetStateAction<JobsDetailsItem[]>>;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
} & LoadMoreJobsHandlerParams;

export async function CreateLoadMoreJobsHandler({
  requestData,
  fetchFunction,
  setHasMoreJobs,
  setRenderedJobIds,
  setLoadMoreData,
  setPageNumber,
  lastLoadedJob,
  loadMoreData,
  renderedJobIds,
  pageSize,
  pageNumber,
}: CreateLoadMoreJobsHandlerProps): Promise<JobsDetailsItem[]> {
  let moreJobs = [] as JobsDetailsItem[];
  try {
    const lastJob =
      loadMoreData.length === 0 ? lastLoadedJob : loadMoreData.at(-1);

    if (lastJob) {
      const newJobs: JobsDetailsItem[] = [];
      moreJobs = await fetchFunction(requestData);
      moreJobs.forEach((job: JobsDetailsItem) => {
        if (!renderedJobIds.has(job.job_id)) {
          newJobs.push(job);
          setRenderedJobIds((prevState) => new Set([...prevState, job.job_id]));
        }
      });
      setLoadMoreData([...loadMoreData, ...newJobs]);
      if (isArrayWithElements(moreJobs)) {
        setPageNumber((prevPageNumber) => prevPageNumber + 1);
        increasePagination((pageNumber + 1).toString());
      }
      if (newJobs.length < pageSize) {
        setHasMoreJobs(false);
      }
    }
  } catch (error) {
    const err = getErrorMessage(error);
    console.error("Something went wrong", err);
  }
  return moreJobs;
}
